"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetToJSON = exports.AssetFromJSONTyped = exports.AssetFromJSON = exports.instanceOfAsset = void 0;
var runtime_1 = require("../runtime");
var Status_1 = require("./Status");
var index_1 = require("./index");
/**
 * Check if a given object implements the Asset interface.
 */
function instanceOfAsset(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "assetType" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    return isInstance;
}
exports.instanceOfAsset = instanceOfAsset;
function AssetFromJSON(json) {
    return AssetFromJSONTyped(json, false);
}
exports.AssetFromJSON = AssetFromJSON;
function AssetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['asset_type'] === 'AUDIO') {
            return (0, index_1.AudioFromJSONTyped)(json, true);
        }
        if (json['asset_type'] === 'IMAGE') {
            return (0, index_1.ImageFromJSONTyped)(json, true);
        }
        if (json['asset_type'] === 'VIDEO') {
            return (0, index_1.VideoFromJSONTyped)(json, true);
        }
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'assetType': json['asset_type'],
        'status': (0, Status_1.StatusFromJSON)(json['status']),
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}
exports.AssetFromJSONTyped = AssetFromJSONTyped;
function AssetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'asset_type': value.assetType,
        'status': (0, Status_1.StatusToJSON)(value.status),
        'url': value.url,
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}
exports.AssetToJSON = AssetToJSON;
